import {
    FETCH_LOYALTY_PROGRAM_RESTAURANTS,
    ADD_RESTAURANT_TO_LOYALTY_PROGRAM,
    REMOVE_RESTAURANT_FROM_LOYALTY_PROGRAM
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_LOYALTY_PROGRAM_RESTAURANTS:
            return action.payload;
        case ADD_RESTAURANT_TO_LOYALTY_PROGRAM:
            return state.concat(action.payload);
        case REMOVE_RESTAURANT_FROM_LOYALTY_PROGRAM:
            return state.filter(restaurant => restaurant.id !== action.payload.restaurantId);
        default:
            return state;
    }
};
